export default "__VITE_ASSET__LrQd$RAY__"